module.exports = __webpack_public_path__ + "img/508.99c9cbf2.png";